import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["result"]
  static values = { url: String }

  async test(event) {
    event.preventDefault()

    // Show loading state
    this.resultTarget.innerHTML = `<span class="text-slate-500">Testing connection...</span>`

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": this.csrfToken()
        }
      })

      const data = await response.json()

      if (response.ok && data.success) {
        this.resultTarget.innerHTML = `
          <div class="rounded-md border border-emerald-200 bg-emerald-50 p-3">
            <p class="font-semibold text-emerald-800">${data.message}</p>
            <p class="mt-1 text-xs text-emerald-700">Status: ${data.status}</p>
            <p class="text-xs text-emerald-700">URL: ${data.url}</p>
          </div>
        `
      } else {
        this.resultTarget.innerHTML = `
          <div class="rounded-md border border-red-200 bg-red-50 p-3">
            <p class="font-semibold text-red-800">${data.message || "Connection failed"}</p>
            ${data.error ? `<p class="mt-1 text-xs text-red-700">${data.error}</p>` : ""}
            ${data.url ? `<p class="text-xs text-red-700">URL: ${data.url}</p>` : ""}
          </div>
        `
      }
    } catch (error) {
      this.resultTarget.innerHTML = `
        <div class="rounded-md border border-red-200 bg-red-50 p-3">
          <p class="font-semibold text-red-800">Connection test failed</p>
          <p class="mt-1 text-xs text-red-700">${error.message}</p>
        </div>
      `
    }
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta && meta.getAttribute("content")
  }
}
